export default {"src":"/_next/static/media/hipl2.905cd11b.svg","height":32,"width":108,"blurWidth":0,"blurHeight":0};